import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AdminDashboard from './AdminDashboard'
import AdminRegistration from './AdminRegistration'
import AdminUserList from './AdminUserList'
import AdminUsersStats from './AdminUsersStats'
import AdminCompany from './AdminCompany'
import AdminSuspended from './AdminSuspended'
import AdminListings from './AdminListings'
import AdminPipeline from './AdminPipeline'
import AdminMessages from './AdminMessages'
import AdminAnalytics from './AdminAnalytics'
import AdminSecurity from './AdminSecurity'
import AdminSettings from './AdminSettings'
import AdminProfile from './AdminProfile'
import AdminPayments from './AdminPayments'
import AdminNotices from './AdminNotices'
import AdminEmailLogs from './AdminEmailLogs'
import AdminBulkEmail from './AdminBulkEmail'
import { AdminChatPage, AdminEmailPage, AdminFilesPage, AdminDigestPage } from './AdminToolPages'

export default function AdminRoutes() {
  return (
    <Routes>
      <Route index element={<AdminDashboard />} />
      <Route path="registration" element={<AdminRegistration />} />
      <Route path="users" element={<AdminUserList />} />
      <Route path="users-stats" element={<AdminUsersStats />} />
      <Route path="companies" element={<AdminCompany />} />
      <Route path="suspended" element={<AdminSuspended />} />
      <Route path="listings" element={<AdminListings />} />
      <Route path="pipeline" element={<AdminPipeline />} />
      <Route path="messages" element={<AdminMessages />} />
      <Route path="chat" element={<AdminChatPage />} />
      <Route path="email" element={<AdminEmailPage />} />
      <Route path="email-logs" element={<AdminEmailLogs />} />
      <Route path="bulk-email" element={<AdminBulkEmail />} />
      <Route path="files" element={<AdminFilesPage />} />
      <Route path="digest" element={<AdminDigestPage />} />
      <Route path="meetings" element={<Navigate to="/admin/chat" replace />} />
      <Route path="analytics" element={<AdminAnalytics />} />
      <Route path="security" element={<AdminSecurity />} />
      <Route path="notices" element={<AdminNotices />} />
      <Route path="profile" element={<AdminProfile />} />
      <Route path="settings" element={<AdminSettings />} />
      <Route path="payments" element={<AdminPayments />} />
      <Route path="cms" element={<Navigate to="/admin/settings?tab=general" replace />} />
      <Route path="moderation" element={<Navigate to="/admin/messages" replace />} />
    </Routes>
  )
}
